import { Injectable } from '@angular/core';
import { HttpClient, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Router, ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs/Observable';
import { UserStorage } from './userStorage';
// import * as bootbox from 'bootbox/bootbox.js';
import * as HttpStatus from 'http-status-codes';
import 'rxjs/add/observable/throw';
import 'rxjs/add/operator/catch';

@Injectable()
export class CustomInterceptor implements HttpInterceptor {
  // unAuth: number[] = [HttpStatus.UNAUTHORIZED];
  unAuth: number[] = [HttpStatus.UNAUTHORIZED];
  unAuthMessage: string;

  constructor(
    private translate: TranslateService,
    private router: Router,
    private user: UserStorage,
    private activatedRoute: ActivatedRoute
  ) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // cross-site Access-Control requests
    req = req.clone({
      withCredentials: true
    });

    // this.translate.get(['msg.forgotPasswordFail']).subscribe(translation => {
    //   this.unAuthMessage = translation['err.sessionTimeout'];
    // });

    return next.handle(req)
            .catch((err: any) => {
              if (this.unAuth.indexOf(err.status) >= 0) {
                this.user.signOut();
                if (location.pathname !== '/' && !this.activatedRoute.snapshot['_routerState'].url.includes('returnUrl')) {
                  this.router.navigate(['/login'], { queryParams: { returnUrl: this.activatedRoute.snapshot['_routerState'].url }});
                  // const dialog = bootbox.dialog({
                  //   message: this.unAuthMessage,
                  //   buttons: {
                  //     ok: {
                  //       label: 'ok',
                  //       className: 'btn-info',
                  //       callback: function() {
                  //         location.href = location.origin;
                  //       }
                  //     }
                  //   }
                  // });
                }
              } else {
                return Observable.throw(err);
              }
            }) as any;
  }
}



// WEBPACK FOOTER //
// /Users/adminuser/Documents/pentagon/pentagon-admin/src/app/helper/customInterceptor.ts